import { Serializable } from '@admin/core/models/serializable';

export class SmsStopReasonModel implements Serializable<SmsStopReasonModel> {
  public smsStopReasonId: number;
  public name: string;

  fromObject(object: any): SmsStopReasonModel {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }
}
